import script from "./CollapsibleSections.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollapsibleSections.vue?vue&type=script&setup=true&lang=ts"

import "./CollapsibleSections.vue?vue&type=style&index=0&id=2d41340e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d41340e"]])

export default __exports__